module.exports = __webpack_public_path__ + "static/media/torchi.88b3baee.png";